import React from 'react';
import { chemistryTheme } from "./chemistryTheme";
import CSSReset from "./CSSReset";
import { ThemeProvider } from "./ThemeProvider";
export var ChemistryProvider = function ChemistryProvider(_ref) {
  var children = _ref.children,
    _ref$cssReset = _ref.cssReset,
    cssReset = _ref$cssReset === void 0 ? true : _ref$cssReset,
    _ref$cssVars = _ref.cssVars,
    cssVars = _ref$cssVars === void 0 ? true : _ref$cssVars;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: chemistryTheme,
    cssVars: cssVars
  }, cssReset && /*#__PURE__*/React.createElement(CSSReset, null), children);
};
export var ChemistryFragmentProvider = function ChemistryFragmentProvider(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(ChemistryProvider, {
    cssVars: false,
    cssReset: false
  }, children);
};